import styles from './sections.css';

<template>
  <div class={{styles.sections}} ...attributes>
    {{yield}}
  </div>
</template>
